import type { PaymentMethod, StorefrontSettings } from "../types";

const known: readonly PaymentMethod[] = ["RAZORPAY", "COD"];

/**
 * Payment methods come only from the storefront API, which offers Razorpay
 * when it is correctly configured for this shopper (live for everyone; test
 * only inside a protected preview session). An older API that does not
 * advertise methods gets cash on delivery only, never an assumed online option.
 */
export function availablePaymentMethods(settings: Pick<StorefrontSettings, "paymentMethods">): PaymentMethod[] {
  const offered = Array.isArray(settings.paymentMethods) ? settings.paymentMethods : [];
  const methods = known.filter((method) => offered.includes(method));
  return methods.length ? methods : ["COD"];
}

/**
 * One token per checkout attempt. Resubmitting with the same token (double
 * click, retry after a network error) returns the same order instead of
 * creating another; a new token is issued once an order has been created or
 * the cart changes.
 */
export function newCheckoutToken(): string {
  return globalThis.crypto.randomUUID();
}
